import React, {Component} from 'react';
import ConspiracyThread from './ConspiracyThread';

class ConspiracyCard extends Component {

  render (){
    const card = this.props.card;
    const centralCard = this.props.centralCard;
    const x = Number(this.props.x || card.x);
    const y = Number(this.props.y || card.y);
    const height = Number(this.props.height || card.height);
    const width = Number(this.props.width || card.width);
    const rotate = this.props.rotate || card.rotate;
    const threaded = centralCard && centralCard !== card;
    return (
      <g>
        <g transform={`rotate(${rotate}, ${x + width/2 - width/20}, ${y + height/150 - height/15})`} className={`card ${this.props.selectCard ? `hoverable` : ''}`} onClick={this.props.selectCard ? this.props.selectCard.bind(null, card): null}>
            <rect x={x} y={y} width={width} height={height} rx="5" ry="5" filter="url(#shadow)" />
            <image xlinkHref={require(`../images/${card.pictureLink}`)} x={x} y={y + 10} height={height*.8} width={width} />
            <text textAnchor="middle" x={x + width/2} y={y + height*.95} className={card.smallerText ? 'smaller-label' : ''}>{card.label}</text>
        </g>
        {threaded
            ? <ConspiracyThread x1={x + width/2} y1={y+height/150+5} x2={centralCard.x + centralCard.width/2} y2={centralCard.y} filter="url(#shadow)" />
            : undefined}
        {centralCard
          ? <image xlinkHref={require('../images/thumbtack.png')}
            x={x + width/2 - width/10} y={y + height/150 - height/15} width={height/5} height={height/5} /> 
          : undefined}
      </g>
    )
  }
}

export default ConspiracyCard;


// WEBPACK FOOTER //
// ./src/components/ConspiracyCard.js